/**
 * useExerciseScoring — Encapsulates self-scoring logic with number-key shortcuts.
 * Eliminates the duplicated pattern in SpeakExercise, RepeatAfterExercise,
 * and PronunciationChallengeExercise.
 */

import { useCallback } from 'react';
import { useNumberKeyShortcuts } from './useKeyboardShortcut';

export function useExerciseScoring(
  scoreValues: number[],
  handleSelfScore: (score: number) => void,
  enabled: boolean
): { handleScoreByIndex: (index: number) => void } {
  const handleScoreByIndex = useCallback(
    (i: number) => {
      if (i < scoreValues.length) {
        handleSelfScore(scoreValues[i]);
      }
    },
    [handleSelfScore, scoreValues]
  );

  useNumberKeyShortcuts(scoreValues.length, handleScoreByIndex, enabled);

  return { handleScoreByIndex };
}
